var global = window

let blockRequest = false

let globalCallback = null

// Création de l'objet pour faire de l'AJAX
global.ajaxRunning = false
global.pageId = null

// Fait afficher/cacher le popup de loading
let loadStartTimer = null
let loadStopTimer = null
global.toggleLoading = function (aff) {
    const speed = 500
    const delay = 0

    if (!document.getElementById('loadingBox')) return false

    if (!ajaxRunning && loadStartTimer && aff == 1) return true

    if (ajaxRunning) {
        loadStopTimer = setTimeout(function () {
            hideLoading(speed)
            clearTimeout(loadStartTimer)
            loadStartTimer = null
        }, speed)
    } else if (loadStartTimer != null) {
        clearTimeout(loadStartTimer)
        loadStartTimer = null
    } else if (aff == 1) {
        loadStartTimer = setTimeout(function () {
            showLoading(speed)
            loadStartTimer = null
        }, delay)
    }
}

global.showLoading = function (speed) {
    ajaxRunning = true
    document.body.style.cursor = 'wait'
    $('#loadingBox').stop(true).addClass('visible')
}

global.hideLoading = function (speed) {
    ajaxRunning = false
    document.body.style.cursor = 'auto'
    $('#loadingBox').stop(true).removeClass('visible')
}

// ======================= Recule dans l'historique
global.historyBack = function (historyHash) {
    const { alreadyRefresh } = localStorage
    if (!alreadyRefresh) {
        const tmpHistory = decode64(historyHash).split('!!')
        if (tmpHistory[0] != undefined) {
            loadPage(tmpHistory[0], tmpHistory[1], false)
        }
        delete localStorage.alreadyRefresh
    }
}

// ================== Load la bonne page ============================================================
let reloadLastId
let reloadLastParametres
global.loadPage = function (id, parametres, width_var, height_var, noHistory) {
    global.pageId = id
    global.delayedInput = 0;
    let hold = false

    if (typeof tinymce == 'object') {
        $.each(tinymce.editors, function (key, editor) {
            if (editor) {
                if (editor.isDirty && editor.isDirty()) {
                    hold = true
                    const confirmation = confirm(
                        'Voulez-vous sauvegarder le contenu du champ ' +
                            editor.id +
                            ' avant de continuer ?'
                    )
                    if (confirmation) {
                        globalCallback = function () {
                            loadPageProcess(id, parametres, width_var, height_var, noHistory)
                        }
                        editor.execCommand('mceSave')
                        hold = true
                    }
                }
                editor.remove()
            }
        })
    }

    if (!hold) {
        loadPageProcess(id, parametres, width_var, height_var, noHistory)
    }
}

global.loadPageUrl = function (url) {
    if (!url) return;
    const queryString = url.includes('?') ? url.substring(url.indexOf('?') + 1) : url;
    const searchParams = new URLSearchParams(queryString);
    let id = searchParams.get('id');

    let params = '';
    const callParam = searchParams.get('call');
    if (callParam) {
        params = callParam.startsWith('&') ? callParam : '&' + callParam;
    } else {
        searchParams.delete('id');
        const rest = searchParams.toString();
        params = rest ? '&' + rest : '';
    }

    if (id) {
        loadPage(id, params);
    }
}

global.initLinks = function (targetSelector) {
    const root = targetSelector ? $(targetSelector) : $(document);
    root.find('a[href*="id="]').off('click.spaLink').on('click.spaLink', function (e) {
        // Laisser passer si CTRL/CMD/Shift/Alt ou clic molette (bouton 2)
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.which === 2) {
            return;
        }

        // Si le lien a une cible externe ou un handler inline, ne pas interférer
        if ($(this).attr('target') === '_blank' || $(this).attr('onclick')) {
            return;
        }

        const href = $(this).attr('href');
        if (!href) return;

        // Vérifier s'il s'agit bien d'une URL interne Centrall (?id=... ou ./?id=... ou SITE_URL?id=...)
        try {
            const urlObj = new URL(href, window.location.href);
            if (urlObj.origin === window.location.origin && urlObj.searchParams.has('id')) {
                e.preventDefault();
                loadPageUrl(urlObj.search);
            }
        } catch (err) {
            if (href.startsWith('?') && href.includes('id=')) {
                e.preventDefault();
                loadPageUrl(href);
            }
        }
    });
};

global.loadPageProcess = function (id, parametres, width_var, height_var, noHistory) {
    const menuSlug = (typeof id === 'string') ? id.replace('.', '-') : id;
    if (!width_var && !height_var) {
        reloadLastId = id
        reloadLastParametres = parametres
    }

    let parametresObj = Object.fromEntries(new URLSearchParams(parametres));
    if (parametresObj.id) id = parametresObj.id;

    if (width_var === true && typeof height_var === 'undefined') {
        window.open(
            SITE_URL + '?id=' + id + '&call=' + escape(parametres) + '',
            '_blank'
        )
        return false
    }

    const debugVar = getJsonFromUrl('https://test.com/?' + parametres)
    $('.debug_id').html(
        id +
            (debugVar && debugVar.page ? '.' + debugVar.page : '') +
            (debugVar && debugVar.tab ? '.' + debugVar.tab : '')
    )
    const time1 = new Date().getTime() / 1000
    if (blockRequest == false) {
        // blockRequest = true;
        // console.log('Je passe ici id = '+id + ' param = ' + parametres);

        // Si une hauteur/largeur n'est pas définie
        if (height_var == null) {
            height_var = 1500
        }
        if (width_var == null) {
            width_var = 0
        }

        // Réinitialise le menu
        const speed = 400
        if (id == 86) {
            $('.menuItem').removeClass('active')
            $('.menuItem:not(.menu-' + 85 + ') img.hover').fadeOut(speed)
            $('.menuItem:not(.menu-' + 85 + ') img.default').fadeIn(speed)

            // Selectionne le bon
            try {
                var favicon = $('.menuItem.menu-' + id).data('favicon')
                $('#favicon').attr(
                    'href',
                    './assets/images/favicon/' + favicon + '.ico'
                )
                $('.menuItem.menu-' + 85 + ' img.default').fadeOut(speed)
                $('.menuItem.menu-' + 85 + ' img.hover').fadeIn(speed)
                $('.menuItem.menu-' + 85).addClass('active')
            } catch (err) {
                err = null
            }
        } else {
            $('.menuItem').removeClass('active')
            $('.menuItem:not(.menu-' + menuSlug + ') img.hover').fadeOut(speed)
            $('.menuItem:not(.menu-' + menuSlug + ') img.default').fadeIn(speed)

            // Selectionne le bon
            try {
                var favicon = $('.menuItem.menu-' + id).data('favicon')
                $('#favicon').attr(
                    'href',
                    './assets/images/favicon/' + favicon + '.ico'
                )
                $('.menuItem.menu-' + menuSlug + ' img.default').fadeOut(speed)
                $('.menuItem.menu-' + menuSlug + ' img.hover').fadeIn(speed)
                $('.menuItem.menu-' + menuSlug).addClass('active')
            } catch (err) {
                err = null
            }
        }
        // Load la page voulue
        ajaxCall({
            url: 'app/modules/loadPage.php',
            data: 'id=' + id + parametres,
            success(response) {
                // blockRequest = false;
                const time2 = new Date().getTime() / 1000
                // console.log("loadPage :" + (time2 - time1));
                // Supprime le popup
                if (document.getElementById('PopupDiv')) {
                    closePopup()
                }

                // Si une largeur est définie c'est un popup
                let responseElement = $(response)
                if (width_var == 0) {
                    const contentHolder = $('.main > .main__inner')
                    onContentUnload(contentHolder)
                    contentHolder.html(responseElement)
                } else {
                    loadPopup(responseElement, width_var, height_var)
                }

                if (response.substr(0, 11) == '<!--OUT -->') {
                    setTimeout("window.location='logoff.php';", 1500)
                    return false
                }

                if (
                    response ==
                    "<h1 class='error_message'>Acc&egrave;s interdit</h1>"
                ) {
                    setTimeout("loadPage(0,'')", 1500)
                    return false
                }

                $('div.global-zeroclipboard-container').remove()

                document.onmousemove = function () {} // Au cas où je m'en suis servi ailleur
                clearTimeout(timerBuffer)


                loadModuleScript(id);

                // ============================================== TEMPORAIRE =======================================
                if (document.getElementById('action')) {
                    if (document.getElementById('action').value == 2) {
                        // Si c'est un ajout, on laisse des champs ordinaires
                        switchAll()
                    } else if (document.getElementById('action').value != 1) {
                        // Si c'est pas une modif, ni un ajout
                        flushModifiableDivs()
                    }
                } else {
                    // Si c'est pas défini
                    flushModifiableDivs()
                }
                // ============================================== TEMPORAIRE =======================================

                // window.scroll(0,0);
                lastEdit = ''

                // Initialisation des Inputs
                onContentLoad(responseElement)

                // Si ya un onLoad a faire, ben le faire...
                if (document.getElementById('loadAction')) {
                    const tmpDelay = new Date().getTime() + 1000
                    while (tmpDelay < new Date().getTime()) {} // Attendre uen seconde que le js se load
                    eval(document.getElementById('loadAction').value)
                    document
                        .getElementById('loadAction')
                        .parentNode.removeChild(
                            document.getElementById('loadAction')
                        )
                }

                // Mettre dans l'historique
                if (noHistory != true) {
                    historyAdd(id, parametres);
                }

                toggleLoading(0)
            },
            error(response) {
                operation_message(
                    'Erreur serveur lors du chargement de la page',
                    'error'
                )
            },
        })
    }

    onContentUnload()

    return true
}

global.historyAdd = function(id, parametres) {
    if (typeof unFocus != 'undefined') {
        // unFocus.History.removeEventListener('historyChange', historyBack);
        localStorage.alreadyRefresh = 'yes'
        unFocus.History.addHistory(encode64(id + '!!' + parametres))
        delete localStorage.alreadyRefresh
    }
}

// ================== Un bon vieux refresh
global.refreshPage = function (newFn) {
    if (newFn) {
        loadPage(reloadLastId, reloadLastParametres)
    } else {
        if (document.getElementById('refreshAction')) {
            eval(document.getElementById('refreshAction').value)
        } else if (document.getElementById('param')) {
            loadPage(
                $('#id').val(),
                $('#param').val()
            )
        }
        refreshZoneMsg()
    }
}

global.callAPI = function (method, url, data, callback, callbackError) {
    toggleLoading(1)

    let apiUrl = APP_URL + '/api/v1/';
    if (url.startsWith("app/")) {
        apiUrl = 'inc.php?incUrl=';
    }

    $.ajax({
        type: method, // POST, PUT, DELETE, GET
        url: apiUrl + url,
        data: JSON.stringify(data),
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: callback,
        headers: { Authorization: 'Bearer ' + getCookie('tokenAPI') },
        error(data) {
            // Non autorisé
            if (data.status == 401) {
                const responseMsg = JSON.parse(data.responseText)
                if (responseMsg.message == 'Unauthenticated.') {
                    alert(
                        "La session de connexion à l'API de CENTRALL est expiré, veuillez vous reconnecter."
                    )
                    setTimeout(function () {
                        window.location.replace('logon.php')
                    }, 1500)
                } else {
                    alert('Accès non autorisé')
                }
            }

            if (callbackError) {
                callbackError(data)
            }
        },
        complete() {
            toggleLoading(0)
        },
    })
}

global.newTab = function (id, params) {
    window.open(SITE_URL + '?id=' + id + '&call=' + escape(params), '_blank')
}

global.ajaxCall = function (params) {
    toggleLoading(1)

    if (!params.type) params.type = 'POST'

    params.complete = function (data, status) {
        if (status == 'success' && globalCallback) {
            globalCallback()
        }
        globalCallback = null
        toggleLoading(0)
    }

    params.url = 'inc.php?incUrl=' + params.url.replace('?', '&')
    var request = $.ajax(params)

    if (params.callback) {
        request.done(function (msg) {
            global.delayedInput = 0;
            params.callback(msg)
        })
    }
}

global.ajaxPopup = function (title, width, height, url, data, callback, icon, event) {
    if (!callback) {
        callback = function () {
            refreshPage()
        }
    }

    if (url) {
        var urlArgs = url.split('?')
        url = urlArgs[0]
        urlArgs = urlArgs[1]
        if (urlArgs) {
            if (!data) {
                data = urlArgs
            } else if (typeof data === 'object') {
                var urlParams = new URLSearchParams(urlArgs)
                urlParams.forEach(function (val, key) {
                    if (data[key] === undefined) {
                        data[key] = val
                    }
                })
            } else if (typeof data === 'string') {
                data = urlArgs + '&' + data
            }
        }
    } else {
        url = ''
    }
    var settings = {
        id: 'centrallPopup',
        title,
        data,
        url: 'popup.php?url=' + url,
        method: 'iframe',
        maxWidth: width, // the minimum width, if -1 means no checking
        maxHeight: height, // the minimum height, if -1 means no checking
        showFooter: false,
        maximizable: false,
        closable: true,
        showModal: true,
        width: width + 'px',
        height: height + 'px',
        checkBoundary: true,
        withinBrowserWindow: false,
        onClose: callback,
        icon,
    }
    $.window(settings)
}

global.ajaxPrint = function (url, data, callback) {
    if (!callback) {
        callback = function () {
            refreshPage()
        }
    }

    if (url) {
        var urlArgs = url.split('?')
        url = urlArgs[0]
        urlArgs = urlArgs[1]
        if (urlArgs && !data) data = urlArgs
    } else {
        url = ''
    }
    url += '&' + urlSerialize(data)

    // Create a hidden iframe
    var iframe = document.createElement('iframe')
    iframe.id = 'toPrint'
    iframe.style.display = 'none'
    document.body.appendChild(iframe)

    // Load the content into the iframe
    iframe.src = 'popup.php?url=' + url

    // Wait for iframe to load before printing
    iframe.onload = function () {
        setTimeout(function () {
            // Print the iframe content
            try {
                window.frames['toPrint'].print()
            } catch (e) {
                console.log(e)
                try {
                    window.frames['toPrint'].contentWindow.print()
                } catch (e) {
                    console.log(e)
                }
            }
        }, 100)

        // Clean up: remove the iframe and call the callback
        setTimeout(function () {
            document.body.removeChild(iframe)
        }, 2000)
        callback()
    }
}

global.onContentLoad = function (content) {
    if (!content) content = $('body')
    else content = $(content)

    initInputs(content)

    initTooltips(content)

    if (typeof initLinks === 'function') {
        initLinks(content)
    }
}

global.onContentUnload = function (content) {
    if (!content) content = $('body')
    else content = $(content)
    if (typeof global.hideTooltip === 'function') {
        global.hideTooltip(true);
    } else {
        $('.protip-container').removeClass('visible');
    }
}

global.addLog = function (data) {
    ajaxCall({
        url: 'app/modules/logs/actions/ajoutLog.php',
        data,
    })
}

global.editLog = function (id, text) {
    ajaxCall({
        url: 'app/modules/logs/actions/modifLog.php',
        data: {
            value: text,
            id,
        },
        success(response) {
            operation_message(response)
        },
    })
}

const debounceTimers = new Map();
global.debounce = function (id, fn, delay = 0) {
    // 1. Annule le timer existant pour cet ID s'il y en a un
    if (debounceTimers.has(id)) {
        clearTimeout(debounceTimers.get(id));
        debounceTimers.delete(id);
    }

    // 2. Si aucune fonction n'est fournie, l'action est simplement annulée
    if (typeof fn !== "function") {
        return;
    }

    // 3. Si aucun délai (ou <= 0), exécution immédiate
    if (!delay || delay <= 0) {
        fn();
        return;
    }

    // 4. Sinon, planifie l'exécution différée
    const timer = setTimeout(() => {
        debounceTimers.delete(id);
        fn();
    }, delay);

    debounceTimers.set(id, timer);
}


window.onerror = function (msg, url, line, col, error) {
    alert(
        "<strong>Une erreur de script est survenu.</strong><br />L'emplacement de l'ereur a été enregistré pour permettre aux développeurs de CENTRALL de corriger cette issue."
    )
    addLog({
        value: msg,
        type: 'ERROR_JS',
        itemType: 'line',
        itemNom: url.split('?')[0],
        itemDesc: 'ligne : ' + line + ' Colonne : ' + col,
        itemId: line,
        idDossier: $('#id_dossier').val(),
        clientId: $('#id_client').val(),
    })

    return false
}

window.loadModuleScript = function(id) {
    const $head = $('head');
    const scriptId = 'scriptPages';
    id = id.toString()

    // Ne rien faire si le script actuel n'existe pas dans modulesJs
    if (modulesJs && !modulesJs.includes(id)) {
        return;
    }
    
    // Supprime l'ancien script s'il existe
    $('#' + scriptId).remove();

    // Crée un nouveau script
    const timestamp = new Date().getTime();
    const $script = $('<script>', {
        id: scriptId,
        src: `assets/js/modules/${id}.js?v=${timestamp}`,
        type: 'text/javascript',
        defer: true
    });

    // Ajoute le script dans le <head>
    $head.append($script);
}
